import { Component, Input, OnInit } from '@angular/core';
import { Labels, SdfCardLabels } from '../../app.models';
import { Store } from '@ngrx/store';
import { defaultCountry } from '../../store/service-options';
import { isLocationSelected } from '../../store/transaction/transaction.selectors';
import { Observable } from 'rxjs';
import { MobileBreakPointsService } from 'src/app/services/mobileBreakPoints.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogLocationMapComponent } from '../dialog-location-map/dialog-location-map.component';
import { StringUtils } from 'src/app/shared/utils/string-utils';

@Component({
    selector: 'app-moneygram-locations-link',
    templateUrl: './moneygram-locations-link.component.html',
    styleUrls: ['./moneygram-locations-link.component.scss'],
    standalone: false
})
export class MoneygramLocationsLinkComponent implements OnInit {
  openDialogMobile: boolean = false;
  isMobileSize: boolean;
  isMobile$: Observable<boolean>;
  public country: string = '';
  isLocationSelected = false;
  sdfCardLabels: SdfCardLabels;
  public isLocationSelected$: Observable<boolean>;
  @Input() kind!: string;
  @Input() isSdfCardFlow = false;
  @Input() flow: string;
  @Input() enableSelectLocationBtn: boolean | null | undefined;
  // @Input() changeLocationButton;
  @Input() labels!: Labels;
  @Input() displaySuperscript!: boolean;
  @Input() google: any;

  public _changeLocationButton: any;
  @Input() public set changeLocationButton(loc: any) {
    this._changeLocationButton = loc;
  }
  public get changeLocationButton() {
    return this._changeLocationButton;
  }

  constructor(
    private store: Store,
    public dialogLocationMap: MatDialog,
    private _mobileBreakPoinntService: MobileBreakPointsService
  ) {
    this.isMobile$ = this._mobileBreakPoinntService.mobileBreakPoints$;
  }
  ngOnInit(): void {
    // console.log("LABELS : ", this.labels);

    this.isMobile$.subscribe((isMobile) => {
      this.isMobileSize = isMobile;
    });
    this.store.select(defaultCountry).subscribe((country) => {
      this.country = country;
    });
    this.isLocationSelected$ = this.store.select(isLocationSelected);
  }

  openDialog(): void {
    const dialogbRef = this.dialogLocationMap.open(DialogLocationMapComponent, {
      data: {
        labels: this.labels,
        google: this.google,
        flow: this.kind,
        isSupportPanelOpen: !this.openDialogMobile,
        toogleSupportPanel: (payload: boolean) => {
          this.toogleDialogMobile(payload);
        },
      },
      backdropClass: 'back-transparent',
      panelClass: 'dialog-no-animations',
    });
    dialogbRef.afterOpened().subscribe(() => {
      this.toogleDialogMobile(!this.openDialogMobile);
    });
  }

  public toogleDialogMobile(openDialogMob: boolean) {
    this.openDialogMobile = openDialogMob;
  }

  public capSentence1Letter(value: string | undefined) {
    return StringUtils.capitalizeWord(value);
  }
}
